import React, { useState, useEffect, useContext, useCallback } from "react";
import useLocalStorage from "../Hooks/useLocalStorage";

const UIContext = React.createContext([{}, () => {}]);
const VIEW_CONSTS = {
  matchSelect: 0,
  live: 1,
  formation: 2,
  stats: 3,
  clockEdit: 4,
  all_graphics: 5,
  penalty: 6,
};

const MODE_CONSTS = {
  live: 0,
  matchChoice: 1,
};

const UIProvider = (props) => {
  const [view, setView] = useState(VIEW_CONSTS.matchSelect);
  const [mode, setMode] = useState(MODE_CONSTS.live);
  const [goal, setGoal] = useState();
  const [selectedTeam, setSelectedTeam] = useState();
  const [editPlayer, setEditPlayer] = useState();
  const [presToggle, setPresToggle] = useState(false);
  const [homeKit, setHomeKit] = useLocalStorage("home-kit", "home");
  const [awayKit, setAwayKit] = useLocalStorage("away-kit", "home");
  const [uiView, setUIView] = useState(0);
  const [homeScore, setHomeScore] = useLocalStorage(
    "hyper-netball-home-score",
    {},
  );
  const [awayScore, setAwayScore] = useLocalStorage(
    "hyper-netball-away-score",
    {},
  );
  const [scoringMode, setScoringMode] = useLocalStorage(
    "hyper-netball-scoring-mode",
    {},
  );
  const [localPeriod, setLocalPeriod] = useLocalStorage(
    "hyper-netball-period",
    {},
  );
  const [extraTimeToggle, setExtraTimeToggle] = useLocalStorage("ExtraTimeToggle", {},);
  const [clockHide, setClockHide] = useLocalStorage("ClockHide", {},);
  return (
    <UIContext.Provider
      value={{
        view,
        setView,
        selectedTeam,
        setSelectedTeam,
        goal,
        setGoal,
        mode,
        setMode,
        editPlayer,
        setEditPlayer,
        uiView,
        setUIView,
        homeKit,
        setHomeKit,
        awayKit,
        setAwayKit,
        homeScore,
        awayScore,
        setHomeScore,
        setAwayScore,
        scoringMode,
        setScoringMode,
        localPeriod,
        setLocalPeriod,
        presToggle,
        setPresToggle,
        extraTimeToggle,
        setExtraTimeToggle,
        clockHide,
        setClockHide,
      }}
    >
      {props.children}
    </UIContext.Provider>
  );
};

export { UIContext, UIProvider, VIEW_CONSTS, MODE_CONSTS };
